import type {
  IImageTransformationsProvider,
  SupportedImageTransformationsProvider,
} from "../../types";
import { bunnyProvider } from "./bunny";
import { cloudflareImagesProvider } from "./cloudflare-images";
import { noneProvider } from "./none";

export function getImageTransformationsProvider(
  override?: SupportedImageTransformationsProvider,
): IImageTransformationsProvider {
  let provider = (override ??
    process.env.NEXT_PUBLIC_IMAGE_TRANSFORMATIONS_PROVIDER) as
    | SupportedImageTransformationsProvider
    | undefined;

  if (!provider) {
    provider = "none";
  }

  let instance: IImageTransformationsProvider;

  switch (provider) {
    case "bunny":
      instance = bunnyProvider;
      break;
    case "cloudflare-images":
      instance = cloudflareImagesProvider;
      break;
    case "none":
      instance = noneProvider;
      break;
  }

  return instance;
}
